const state = {
    admin: {},
    reply: { text: '', stauts: 'done'},
    list: [],
    error: false,
    done: false,
    loading: false,
    page_loading: false,
    last_page: false,
    current_page: null,
}

const getters = {

}

const mutations = {
    initAdmin(state, payload) {
        state.admin = payload
    },
    getMessageList(state, payload) {
        state.list = payload
    },
    updateAdmin(state, payload) {
        let admin = { ...state.admin }
        state.admin =  Object.assign(admin, payload)
    },
    updateReply(state, payload) {
        state.reply = payload
    },
    pushMessage(state, payload) {
        state.list.push(payload)
    },
    getMessagePagination(state, payload) {
        state.list = payload.concat(state.list)
    },
    showMessageLoading(state) {
        state.loading = true
    },
    closeMessageLoading(state) {
        state.loading = false
    },
    showMessagePageLoading(state) {
        state.page_loading = true
    },
    closeMessagePageLoading(state) {
        state.page_loading = false
    },
    updateMessagePage(state, { last_page, current_page }) {
        state.last_page = last_page
        state.current_page = current_page
    },
    updateMessageUnread(state) {
        state.list.forEach(l => {
            l.is_read = '1'
        })
    }
}

const actions = {
    initMessage({commit, state}, payload) {
        setTimeout(() => {
            commit('closeMessageLoading')
        }, 300)
        commit('initAdmin', payload.admin)
        commit('getMessageList', payload.list)
    },
    getMessage({commit, state}, { admin, message}) {
        commit( 'updateAdmin', admin || {})
        commit( 'pushMessage', message )
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/messageList/index.js